/** @file Curve-graph colours and font from the ui-kit tokens (`--p2-*`), read through a lookup. */
import type { CurveStyle } from './curveCanvasTypes';

/** Track colours cycle through these tokens, in this order. */
const PALETTE = ['--p2-accent', '--p2-animate', '--p2-danger', '--p2-focus-ring', '--p2-fg', '--p2-fg-muted'];

/** `read(name)` returns a custom property's value (the view passes getComputedStyle(canvas).getPropertyValue). */
export function curveStyleFrom(read: (name: string) => string): CurveStyle {
  const token = (name: string): string => read(name).trim();
  return {
    background: token('--p2-bg-input'),
    ruler: token('--p2-bg-raised'),
    grid: token('--p2-border'),
    text: token('--p2-fg-muted'),
    palette: PALETTE.map(token),
    selected: token('--p2-accent-fg'),
    playhead: token('--p2-animate'),
    font: `${token('--p2-font-size')} ${token('--p2-font-mono')}`,
  };
}
